// project imports
import accounts from './accounts';
import proaccounts from './pro-accounts';
import numbers from './numbers';
import ports from './ports';
import rates from './rates';
import numbering from './numbering';
import overrides from './overrides';
import vouchers from './vouchers';
import resellers from './resellers';
import wholesales from './wholesales';
import userManagement from './user-management';
import banking from './banking';
import platform from './platform';
import finance from './finance';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [accounts, proaccounts, numbers, ports, numbering, rates, overrides, vouchers, banking, resellers, wholesales, platform, finance, userManagement]
};

export default menuItems;
